import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=e28b7db8&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=e28b7db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28b7db8",
  null
  
)

export default component.exports